var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarningWelcome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 80C17.9086 80 0 62.0914 0 40C0 17.9086 17.9086 0 40 0C62.0914 0 80 17.9086 80 40C80 62.0914 62.0914 80 40 80ZM73 40.3815C73 58.5637 58.2254 73.3033 40 73.3033C21.7746 73.3033 7 58.5637 7 40.3815C7 22.1993 21.7746 7.4597 40 7.4597C58.2254 7.4597 73 22.1993 73 40.3815ZM44.9155 20.1296H36.1835L37.5995 47.6761H43.4405L44.9155 20.1296ZM37.1275 60.4488C38.0322 61.3121 39.1728 61.7437 40.5495 61.7437C41.8868 61.7437 42.9882 61.3121 43.8535 60.4488C44.7582 59.5463 45.2105 58.4475 45.2105 57.1526C45.2105 55.8577 44.7582 54.7786 43.8535 53.9153C42.9882 53.052 41.8868 52.6204 40.5495 52.6204C39.1728 52.6204 38.0322 53.052 37.1275 53.9153C36.2228 54.7786 35.7705 55.8577 35.7705 57.1526C35.7705 58.4475 36.2228 59.5463 37.1275 60.4488Z",
    fill: "#FF9E1B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningWelcome);
export default __webpack_public_path__ + "static/media/WarningWelcome.5822ec0ab06acc02497a5e811d588c48.svg";
export { ForwardRef as ReactComponent };